export default __webpack_public_path__ + "static/media/natty_info.8fc64819.jpg";